import SharingPermissionItemState from '../store/schema/SharingPermissionItemState';
import { CalendarSharingState } from '../store/schema/CalendarSharingStore';

/**
 * The utility function to find sharing permission is of person inside/outside org or delegate.
 * @param sharingPermissionItem The sharing permission item received from UI
 * @param viewState The store state
 */
export default function(
    sharingPermissionItem: SharingPermissionItemState,
    viewState: CalendarSharingState
) {
    let isInsideOrg =
        sharingPermissionItem.IsInsideOrganization &&
        sharingPermissionItem.CurrentDetailLevel != 'Delegate';
    let isDelegate =
        sharingPermissionItem.IsInsideOrganization &&
        sharingPermissionItem.CurrentDetailLevel == 'Delegate';
    let isOutsideOrg = !sharingPermissionItem.IsInsideOrganization;

    let sharingPermissionsListToSearch: SharingPermissionItemState[] = [];

    if (isInsideOrg && viewState.peopleInsideOrg) {
        sharingPermissionsListToSearch = viewState.peopleInsideOrg;
    } else if (isOutsideOrg && viewState.peopleOutsideOrg) {
        sharingPermissionsListToSearch = viewState.peopleOutsideOrg;
    } else if (isDelegate && viewState.delegates) {
        sharingPermissionsListToSearch = viewState.delegates;
    }

    return sharingPermissionsListToSearch;
}
